import TextField from '~components/ui/text-input/text-field'

type Props = Readonly<{
  onAgeChange: (date: string) => void
  ageErrorMessage: string
  age?: string
  label?: string
}>

const PetAge = ({ onAgeChange, age, ageErrorMessage, label }: Props) => {
  return (
    <div className="relative">
      <TextField
        onFocus={() => {
          onAgeChange('')
        }}
        label={label}
        value={age}
        onChange={e => {
          onAgeChange(e.target.value)
        }}
        placeholder="MM/DD/YYYY"
        inputMode="numeric"
        error={!!ageErrorMessage}
        showHelper
        helperMessage={ageErrorMessage}
      />
    </div>
  )
}

export default PetAge
